module.exports = __webpack_public_path__ + "images/assets/02ad5883c3e50ad091e802c4f7e37057.svg";